export const MODAL_TYPE = {
  UPDATE_FILE_NAME: 'UPDATE_FILE_NAME',
  ARCHIVE_PROPOSAL: 'ARCHIVE_PROPOSAL',
  ITINERARY_CONFIRM: 'ITINERARY_CONFIRM',
  ASSIGN_TO: 'ASSIGN_TO',
  SHARE_WITH: 'SHARE_WITH',
  ACTIVITY_LOG: 'ACTIVITY_LOG',
  SHARE_SAMPLE_ITINERARY: 'SHARE_SAMPLE_ITINERARY',
  UPDATE_BEDNIGHTS: 'UPDATE_BEDNIGHTS',
  PRIVACY_POLICY: 'privacy-policy',
  TERMS_OF_SERVICE: 'terms-of-service',
} as const;
